module.exports = __webpack_public_path__ + "media/images/logo-9167d609b09ca1c04b33ff62e9601872.svg";